export default {
  sinceJobStart: 'Od początku zadania',
  sinceFirstInBand: 'Od pierwszej wartości w paśmie',
};
